import { render, staticRenderFns } from "./ConsultaUsuario.vue?vue&type=template&id=087edc78&"
import script from "./ConsultaUsuario.vue?vue&type=script&lang=js&"
export * from "./ConsultaUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports